import React from 'react';

function ProductDetailsIconJag(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4573_90478)">
        <path
          d="M5.95838 1.33398C5.79952 1.36393 5.68494 1.50456 5.68754 1.66732V17.6673C5.68754 17.8509 5.83728 18.0007 6.02088 18.0007H9.10421C9.27348 18.002 9.41671 17.877 9.43754 17.709L10.3334 9.63607L11.2292 17.709C11.25 17.877 11.3933 18.002 11.5625 18.0007H14.6459C14.8295 18.0007 14.9792 17.8509 14.9792 17.6673V1.66732C14.9792 1.48372 14.8295 1.33398 14.6459 1.33398H6.02088C6.01046 1.33398 6.00004 1.33398 5.98963 1.33398C5.97921 1.33398 5.96879 1.33398 5.95838 1.33398ZM6.35421 2.00065H14.3125V2.66732H12.3959C12.3516 2.6582 12.3047 2.6582 12.2605 2.66732H8.39588C8.35161 2.6582 8.30473 2.6582 8.26046 2.66732H6.35421V2.00065ZM6.35421 3.33398H7.98963C7.91411 4.42904 7.4714 4.97982 7.04171 5.29232C6.77739 5.48503 6.53129 5.56966 6.35421 5.61523V3.33398ZM8.64588 3.33398H12.0209C12.1055 4.62305 12.655 5.4056 13.2292 5.82357C13.6563 6.13477 14.0821 6.24414 14.3125 6.29232V17.334H11.8646L10.6667 6.55273C10.6641 6.37044 10.5157 6.22461 10.3334 6.22461C10.1511 6.22461 10.0026 6.37044 10 6.55273L8.80213 17.334H6.35421V6.29232C6.58468 6.24414 7.01046 6.13477 7.43754 5.82357C8.01176 5.4056 8.56124 4.62305 8.64588 3.33398ZM12.6771 3.33398H14.3125V5.61523C14.1355 5.56966 13.8894 5.48503 13.625 5.29232C13.1954 4.97982 12.7526 4.42904 12.6771 3.33398Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_4573_90478">
          <rect
            width="16.6667"
            height="16.6667"
            fill="white"
            transform="translate(2 1.33398)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ProductDetailsIconJag;
